import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_DISCLOSURE_TIMING_ACTION_TYPE } from '../actions/disclosureTiming.actions';

const initialState = null;

const disclosureTimingReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_DISCLOSURE_TIMING_ACTION_TYPE.SET_DISCLOSURE_TIMING:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default disclosureTimingReducer;
